import { useState } from 'react';

import { usePusherEvent } from '../../../../hooks/use-pusher-event';
import { CSV_IMPORT_PROGRESS } from '../../../../services/pusher-service/pusher-contract-messages';

/**
 * Hook to manage the progress of a CSV import.
 * @param {import('../types/import-type').ImportTypes} importType - The type of import to manage
 * @returns {import('../types/types').ImportProgressType | null} - The progress of the import
 */
export const useCsvImportProgress = (importType) => {
  const [progress, setProgress] = useState(null);

  /**
   * @param {object} message - The message received from the Pusher event
   * @returns {void}
   */
  const getProgress = (message) => {
    if (message.importType.toLowerCase() === importType.toLowerCase()) {
      setProgress(message);
    }
  };

  usePusherEvent(CSV_IMPORT_PROGRESS, getProgress);

  return progress;
};
